import { loadStripe } from '@stripe/stripe-js';
import React, { useContext } from 'react';
import { useQueryClient } from 'react-query';

import { ModalType } from '@/API/models';
import BaseModal from '@/components/Modals/BaseModal';
import { EditProfileContext } from '@/contexts/EditProfileProvider';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';
import { useSubscriptionCheckout } from '@/Utils/stripeHooks/useSubscriptionCheckout';
import { updatedSubscriptionAlertMessageOptions } from '@/Utils/useAlertMessage';

type Props = {
  handleOpenModal: (type: ModalType) => void;
  selectedPlanPriceId: string;
};

const DowngradeModal: React.FC<Props> = ({
  handleOpenModal,
  selectedPlanPriceId,
}) => {
  const { stripeKey, showAlert } = useContext(EditProfileContext);
  const queryClient = useQueryClient();
  const { data: user } = useCurrentUser();

  const { mutateAsync: checkout, isLoading } = useSubscriptionCheckout({
    onSuccess: async (res) => {
      let errorMessage: string | null = null;
      if (stripeKey && res && 'payment_intent_client_secret' in res) {
        const stripe = await loadStripe(stripeKey);
        const confirmRes = await stripe?.confirmCardPayment(
          res.payment_intent_client_secret,
        );

        if (confirmRes?.error?.message) {
          errorMessage = confirmRes.error.message;
        } 
      }

      queryClient.invalidateQueries(['currentUser']);
      handleOpenModal(null);

      if (errorMessage) {
        showAlert({ type: 'error', description: errorMessage });
      } else {
        showAlert(updatedSubscriptionAlertMessageOptions);
      }
    },

  });

  const handleDowngrade = async () => {
    if (!user?.phone_verified_at || !user.phone) {
      document.cookie = `subscription_price_id=${selectedPlanPriceId}; path=/; Secure`;
      window.location.href = '/users/phone_number_verification';
    } else {
      await checkout({ price_id: selectedPlanPriceId });
    }
  };

  return (
    <BaseModal
      icon='/icons/warning-full.svg'
      title='Are You Sure You Want to Downgrade?'
      text='Are you sure you want to downgrade? Your current balance will be prorated.'
      cancelButton
      primaryButtonText='Downgrade'
      handlePrimaryButton={handleDowngrade}
      handleCancel={() => handleOpenModal(null)}
      isLoading={isLoading}
    />
  );
};
export default DowngradeModal;
